module.exports = __webpack_public_path__ + "assets/img/img-chara-require.b9fca6f3.svg";